import { BaseController } from "./base_controller";

export default class extends BaseController {
  connect() {
    setTimeout(() => this.dispatchToWindow("countryChanged", {...this.element.dataset}), 300);
  }
}
